import { render, staticRenderFns } from "./OrderPaymentForm.vue?vue&type=template&id=785dc1ec"
import script from "./OrderPaymentForm.vue?vue&type=script&lang=js"
export * from "./OrderPaymentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports